/**
 * Converts a class level to a class name.
 * Unknown class levels will return '-'.
 *
 * @param {Array<Object>} levels An array of levels from the levels store.
 * @param {number} classLevel The ID of the class level.
 * @param {boolean=} short
 * @returns {string}
 */
export const classLevelToName = (levels, classLevel, short) => {
  const level = levels.find(level => level['Level']['id'] === classLevel)

  if (level) {
    return level['Level'][short ? 'short' : 'name']
  }

  return '-'
}

/**
 * Converts a class level span to a readable string.
 *
 * @param {Array<Object>} levels An array of levels from the levels store.
 * @param {number|Array<number>} minClassLevel The ID of the lowest class level (or an array of 2 class levels).
 * @param {number|undefined=} maxClassLevel The ID of the highest class level (or undefined if an array was passed as `minClassLevel`).
 * @param {boolean=} short
 * @returns {string}
 */
export const classSpanToName = (
  levels,
  minClassLevel,
  maxClassLevel,
  short
) => {
  if (Array.isArray(minClassLevel)) {
    maxClassLevel =
      minClassLevel.length > 1 ? minClassLevel[1] : minClassLevel[0]
    minClassLevel = minClassLevel[0]
  }

  if (minClassLevel === maxClassLevel) {
    return classLevelToName(levels, minClassLevel, short)
  }

  return (
    classLevelToName(levels, minClassLevel, true) +
    ' - ' +
    classLevelToName(levels, maxClassLevel, short)
  )
}
